// extracted by mini-css-extract-plugin
export default {"frames-control":"lsf-frames-control","waiting":"lsf-waiting"};